import type { FC } from "react"

import { useTranslation } from "react-i18next"
import { useRecoilValue } from "recoil"
import styled from "styled-components"

import { ReactComponent as Exclamation } from "@svg/disabled-exclamation.svg"

import { designPreventionToastIsOpenState } from "../state/phase/blockers"

const Wrapper = styled.div<{ isOpen: boolean }>`
  display: flex;
  max-width: 333px;
  padding: 16px;
  position: absolute;
  background: var(--white);
  border-radius: 4px;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.161);
  z-index: 5000;
  top: ${({ isOpen }) => (isOpen ? `16px` : `-100px`)};
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  right: 16px;
  gap: 16px;
  transition: all 0.2s ease-in-out;
  div {
    display: flex;
    &[data-role="prevention-title"] {
      flex-direction: column;
      gap: 4px;
      padding-top: 1px;
      p {
        font-size: 12px;
        line-height: 14px;
        font-weight: 600;
        color: var(--blue-dark-font);
        &[data-role="prevention-summary"] {
          font-weight: 500;
          color: var(--grey-dark);
        }
      }
    }
  }
  svg {
    &[data-role="prevention-icon"] {
      height: 16px;
      width: 16px;
    }
  }
`

export const DesignPreventionToast: FC = () => {
  const { t } = useTranslation()
  const isOpen = useRecoilValue(designPreventionToastIsOpenState)

  return (
    <Wrapper isOpen={isOpen}>
      <div>
        <Exclamation data-role="prevention-icon" />
      </div>
      <div data-role="prevention-title">
        <p>{t(`designPreventionTitle`)}</p>
        <p data-role="prevention-summary">{t(`designPreventionDesc`)}</p>
      </div>
    </Wrapper>
  )
}
